
// 미니프로필 레이어
NP.miniProfile = (function( $ ) {
	var instance;

	function miniProfile( optAll ) {
		this.optAll = $.extend({
			time : 200,
			delay : 300,
			duration : 80,
			gap : 3
		}, optAll || {});

		// layer outline 생성
		$( 'body' ).append( NP.template.miniProfileLayer( this.optAll.id.replace('#', '') ) );

		this.isOn = this.onOver = false;
		this.els = $( this.optAll.elClass );
		this._flyout = $( this.optAll.id );

		// 마우스오버 영역 event binding
		$( 'body' ).on( 'mouseover', this.optAll.elClass, function() {
			instance.show( $( this ) );
		}).on( 'mouseout', this.optAll.elClass, function() {
			instance.hide( $( this ) );
		});

		// 미니프로필 영역 event binding
		this._flyout.on( 'mouseenter',  function() {
			clearTimeout( instance.ct );
			instance.onOver = true;
		}).on ( 'mouseleave' , function() {
			instance.hide();
		});
	}

	miniProfile.prototype.show = function( el ) {
		clearTimeout( instance.ct );

		instance.ct = setTimeout(function() {
			if ( !instance.onOver ) return;

			clearTimeout( instance.ct );
			instance.data( el );

			var oH = instance._flyout.height(),
				oW = instance._flyout.width(),
				w = $( window ),
				o = el.offset(),
				t = w.scrollTop() + w.height() >= o.top + el.height() + oH + instance.optAll.gap;

			instance._flyout.css({
				position : 'absolute',
				top : parseInt( o.top + ( t ? el.height() + instance.optAll.gap : -oH - instance.optAll.gap ) ),
				left : parseInt( o.left )
			}).appendTo('body');

			instance.isOn = true;
		}, instance.optAll.delay);

		instance.onOver = true;
	};

	miniProfile.prototype.hide = function() {
		clearTimeout( instance.ct );

		instance.ct = setTimeout(function() {
			if ( instance.isOn ) {
				instance._flyout.hide();
				instance.isOn = false;
			}
		}, instance.optAll.time);

		instance.onOver = false;
	};


	miniProfile.prototype.data = function( el ) {
		var data = el.data( 'np' );

		if ( !data ) {
			return;
		}

		function msg( code ) {
			var txt;
			if ( code === '302' ) {
				txt = '죄송합니다.<br />로그인 후 다시 이용해 주세요.';
			} else {
				txt = '에러가 발생하였습니다.<br />잠시 후 이용해 주세요.';
			}

			instance._flyout.find('.loading').fadeOut();
			instance._flyout.find('.txt_error').html( txt ).show();
		}

		jQuery.ajax({
			type : 'get',
			url : NP.prflUri( data.id ) + '/my/profile/miniProfile.jsonp',
			dataType : 'jsonp',
			beforeSend : function() {
				NP.zIndex['+']( instance._flyout );
				instance._flyout.find('.txt_error').hide();
				instance._flyout.find('.loading').show();
				instance._flyout.show();
			},
			success : function( data, status ) {
				if ( data.systemException ) {
					msg();
					return;
				}

				if ( data.miniProfile ) {
					var layer = instance._flyout;
					layer.find('.loading').fadeOut();

					layer.find('.ly_miniProfile').remove();

					//생일
					var birth = '';
					if ( data.miniProfile.profile.birthday ) {
						birth = data.miniProfile.profile.birthday.split( '-' );
						birth = birth[ 1 ].replace( /^0/, '' ) + '.' + birth[ 2 ].replace( /^0/, '' );
					}

					// 성별
					var sex = '';
					if ( data.miniProfile.profile.sexOpenYn === 'Y' && data.miniProfile.profile.sexClfSeq !== 0 ) {
						if ( data.miniProfile.profile.sexClfSeq === 2 ) {
							sex = '(남)';
						} else if ( data.miniProfile.profile.sexClfSeq === 3 ) {
							sex = '(여)';
						}
					}

					// 함께아는친구
					var withFriendCount = 0,
						withFriend = [];
					if ( data.withFriend!=undefined ) {
						withFriendCount = data.withFriend.count;
						withFriend = data.withFriend.list.slice(0, 8);
					}

					// 친구 관계
					var friendRelation = false;
					if ( data.miniProfile.friendReference && data.miniProfile.friendReference.receivedProposals[ 0 ] ) { // 받은 친구 신청
						friendRelation = "friendAccept";
					} else if ( data.miniProfile.friendReference && data.miniProfile.friendReference.sentProposals[ 0 ] ) { // 보낸 친구 신청
						friendRelation = "sentProposals";
					} else if ( data.miniProfile.friendReference.friendRelation === 'FRIEND' || data.miniProfile.friendReference.friendRelation === 'BLOCKED' || data.miniProfile.friendReference.friendRelation === 'BLOCKING' ) { // 친구
						friendRelation = "friend";
					} else { // 친구신청
						friendRelation = "none";
					}

					// 구독 관계
					var followRelation = false;
					if ( data.miniProfile.friendReference.followRelation === 'FOLLOWEE' || data.miniProfile.friendReference.followRelation === 'FOLLOWEE_FOLLOWER' ) {
						followRelation = "following";
					} else { // 친구신청
						followRelation = "follow";
					}

					layer.find('.loading').before(
						NP.template.miniProfileLayerCont({
							all : data,
							playncAcctId : data.miniProfile.profile.playncAcctId,
							userName : data.miniProfile.profile.userName,
							mobileUser : data.miniProfile.mobileUser,
							birthday : birth,
							sex : sex,
							intro : data.miniProfile.profile.prflIntroTxt,
							withFriendCount : withFriendCount,
							withFriend : withFriend,
							friendCount : data.miniProfile.friendCount,
							friendRelation : friendRelation,
							followRelation : followRelation
						})
					);

					layer.fadeIn( instance.optAll.duration );
				} else {
					return '';
				}
			},
			error : function() {
				msg();
			}
		});
	};

	return {
		getInstance : function( optAll ) {
			if ( !instance ) {
				instance = new miniProfile( optAll );
			}
			return instance;
		}
	};
}( jQuery ));


var mProfile = NP.miniProfile.getInstance({
	elClass : '.js_mProfile',
	id : '#flyoutMProfile'
});